import { toFormattedNumber } from "../../../helpers/currencies";
import EmployerStatSummary, {
  EmployerStatSummaryDisplayProps,
} from "./EmployerStatSummary";

const EmployerAutoUxRecommendationStat = ({
  recommendAutoUxPercentage,
  showTitle,
  navigateOnClick,
  config,
}: {
  recommendAutoUxPercentage: number;
} & EmployerStatSummaryDisplayProps) => {
  return (
    <EmployerStatSummary
      title="Auto-UX Recommendation"
      imageUrl="/analytics/recommendation.png"
      value={`${toFormattedNumber(recommendAutoUxPercentage, 0)}%`}
      page="employerViewAnalyticsVehicleSettlementSurveyResponses"
      showTitle={showTitle}
      navigateOnClick={navigateOnClick}
      config={config}
    />
  );
};

export default EmployerAutoUxRecommendationStat;
